export const duTexts = {
  // Titles
  encyclopediaTitle: "Ghalichin Enzyklopädie",
  insuranceAndServicesTitle: "Ghalichin Versicherung und Dienstleistungen",
  generatorTitle: "Ghalichin Generator",

  home: "Zuhause",
  menu: "Menu",
  contactUs: "kontaktiere uns",
  loginRegister: "Anmeldung/ Registrieren",
  encyclopedia: "Enzyklopädie",
  vr: "virtuelle Realität",
  buy: "Kaufen",
  loading: "Wird geladen",
  rugGenerate: "Teppichlayout",
  insuranceAndServices: "Versicherung und Dienstleistungen",
  insurance: " Versicherung",
  brand: "Marke",
  shaneh: "Teppich Schilf",
  density: "Dichte",
  yarn: "Garn",
  rug_size_6: "Teppichgröße 6",
  rug_size_9: "Teppichgröße 9",
  rug_size_12: "Teppichgröße 12",
  decoration: "Dekoration",
  room_services: "Zimmerservice",
  floor_covering: "Bodenbelag",
  wall: "Wand",
  roof: "Dach",
  selectImage: "Bild auswählen",
  wishListText:
    "Sie können die erstellten Teppiche zur Favoritenliste hinzufügen, um später eine Vorschau davon zu sehen.",
  services: "Dienstleistungen",
  specialPosts: "spezielle Beiträge",
  preview: "Vorschau",
  lachakToranj: "Lachak Toranj",
  modern: "modern",
  afshan: "afshan",
  kheshti: "kheshti",
  your_picture: "Your Picture",
  border: "Rand",
  corner: "Ecke",
  background: "Hintergrund",
  toranj: "Toranj",
  tile: "Fliese",
  pattern: "Muster",
  rugSettings: "Fliese",
  wishList: "Wunschzettel",
  addToWishList: "zur Wunschliste hinzufügen",
  listIsEmpty: "Liste ist leer",
  rotate: "drehen",
  clear: "klar",
  latest: "neueste",
  oldest: "älteste",
  onSale: "im Angebot",
  searchingForSellers: "Suche nach Verkäufern",
  storesForThisRug: "speichert für diesen Teppich",
  noStoreForSelectedRug: "Kein Geschäft für ausgewählten Teppich",
  selectOneSimilarRug: "Wählen Sie einen ähnlichen Teppich",
  selectedRugs: "ausgewählte Teppiche",
  rugSimilarityPercentage: "Teppich Ähnlichkeit Prozentsatz",
  similarRugs: "ähnliche Teppiche",
  availableRugSizes: "verfügbare Teppichgrößen",
  phoneNumber: "Telefonnummer",
  address: "Adresse",
  filters: "Filter",
  filter: "Filter",
  previewEmptyHelpText:
    "Sie müssen der Liste mindestens einen Teppich hinzufügen",
  camera: "Camera",
  upload: "Upload",
  selectSizeYourPic: "اندازه فرش",
  // Texts

  landingText: `Die Schaffung eines Mehrwerts für den Kaufprozess ist eines der Hauptanliegen eines jeden Unternehmens. Dieser Mehrwert kann auf drei Arten untersucht und umgesetzt werden. Aus Sicht des Verbrauchers, des Verkäufers und letztendlich des Herstellers. Ziel von Ghalichin ist es, diesen Mehrwert in einer digitalen und sicheren Plattform zu schaffen. Unser Ansatz ist es, den Verkauf und Kauf von"Teppichwaren" in einer neuen und zuverlässigen Umgebung anzubieten.`,

  wikipediaBoldText: `Was ist der Unterschied zwischen maschinell hergestellten und handgeknüpften Teppichen? Worauf sollte ich bei der Auswahl eines hochwertigen Teppichs achten? Wie wähle ich die Größe des Teppichs? Was ist die richtige Teppichfarbe für mein Dekor? Was bedeutet Kamm und Dichte in einem Autoteppich? Was bedeutet Raj in Handknoten?`,

  wikipediaLightText: `Ausreichende Informationen vor dem Kauf sind eine der Voraussetzungen für den Kauf eines Produkts. Ghalichin in der Enzyklopädie versucht, Ihre Fragen zu beantworten und die genauesten Informationen über Material, Design, Eleganz, Fasern, Farbe, Abmessungen und Design des Teppichs und Teppichs bereitzustellen`,
  layOutBoldText: `Wie war die Form der Teppich-Bergamotte meines Nachbarn? Stimmen Sie zu, dass der Hintergrund ihrer Teppiche für unsere Wohnkultur sehr gut geeignet war? `,

  layOutLightText: `Teppichlayout ist unser besonderer und exklusiver Service für diejenigen, die daran interessiert sind, mit den Details ihres Teppichs zu spielen, den Teppich zu finden, der ihrer Wahl am nächsten kommt, und ihn aus dem nächsten Teppich vorzubereiten, um ihren Wohnsitz zu lösen`,
  VRBoldText: `I wish we would say bring all four carpets home and we will choose one. Does a modern carpet fit our decor more or a traditional one? Will the carpet on the parquet be good?`,

  VRLightText: `Es mag Ihnen passiert sein, dass Sie beim Kauf von Teppichen einige der Designs mögen, aber es ist Ihnen nicht möglich, alle diese Teppiche in Ihrem Haus zu verteilen und ihr Aussehen mit Ihrer Heimdekoration zu sehen und die beste Option zu wählen.Ghalichin hat viele Ideen für Ihr Bedürfnis. Die Simulation Ihres Hauses ist der Anfang dieses Weges und wird fortgesetzt`,
  shoppingBoldText: `Weißt du, von wem du kaufst? Kann man ihm vertrauen, ist es kein Betrug? Schicken sie den Teppich? Ist es nicht besser, persönlich zu kaufen?`,

  shoppingLightText: `Die Schaffung einer sicheren Plattform für den Handel war schon immer ein Anliegen von Verbrauchern und Verkäufern. Das Vertrauen in das Online-Verkaufsumfeld ist weitaus komplexer, und dies ist eines der Hindernisse für die Expansion dieses Marktes, insbesondere für wertvolle Produkte. Galichin hat versucht, eine sichere und zuverlässige Verkaufsplattform für den Kauf von Teppichen für Verbraucher und den Verkauf von Teppichen für Lieferanten bereitzustellen, indem geeignete Mechanismen geschaffen wurden`,

  insuranceBoldText: `Ich wünschte, der Verkäufer würde den Teppich regelmäßig waschen? Wo kann ich den Teppich waschen, damit er nicht verderbt? Ich wünschte, sie würden unseren alten Teppich nehmen und ihn für eine bestimmte Menge durch einen neuen ersetzen!Gibt es einen Ort, an dem ich einen Teppich mieten kann? Mieten sie neue Teppiche?`,

  insuranceLightText: `Der Kundendienst und die Garantie für wertvolle Waren wie Teppiche machen das Einkaufen für jeden Kunden angenehmer und sicherer. Entsprechend den Kundenbedürfnissen bietet Ghalichin neben verschiedenen Kundendienstleistungen auch andere wertvolle Dienstleistungen an. Dienstleistungen wie kostenloses Waschen! Ersetzen Sie Ihren alten Teppich durch einen neuen! Und Teppichverleih für den kurzfristigen Einsatz von Teppichen !!! `,

  insuranceText: `Wir sind alle daran interessiert, an einem Ort zu kaufen, der uns sowohl zum Zeitpunkt des Kaufs als auch des Kundendienstes die besten Optionen bietet. Ghalichin bietet diesbezüglich auch eine Vielzahl von Dienstleistungen an. Zum Beispiel den Verbraucher. Eine Person, die gekauft hat Der versicherte Teppich von Ghalichin kann vom ersten kostenlosen Waschen seines Teppichs profitieren oder nach einer Weile erhält er einen neuen Teppich, indem er einen Teil der Kosten bezahlt. Der Teppichverleih ist ein weiterer Service, der in Kürze eingeführt wird`,

  servicesText: `Wir sind alle daran interessiert, an einem Ort zu kaufen, der uns sowohl zum Zeitpunkt des Kaufs als auch des Kundendienstes die besten Optionen bietet. Ghalichin bietet diesbezüglich auch eine Vielzahl von Dienstleistungen an. Zum Beispiel den Verbraucher. Eine Person, die gekauft hat Der versicherte Teppich von Ghalichin kann vom ersten kostenlosen Waschen seines Teppichs profitieren oder nach einer Weile erhält er einen neuen Teppich, indem er einen Teil der Kosten bezahlt. Der Teppichverleih ist ein weiterer Service, der in Kürze eingeführt wird`,
  Custom_Your_Carpet: "Custom Your Carpet",
  image_registration: "Image Registration",
  zoom: "Zoom",
  confirmation_and_approval: "Confirmation and Approval",
  name_and_lastname: "First Name and Last Name",
  Phone_call: "Phone Call",
  Address: "Address",
  send: "Send",
  ordering: "Ordering",
  carpet_show: "Carpet Display",
  back_market: "Back to Market",
  next: "Next",
  previous: "Previous",
  carpet_link: "Your Desired Carpet Link",
  national_Code: "National Code",
  upload_photo_and_video: "Upload Photo and Video of Your Carpet",
  photo_or_video_link: "Photo or Video Link",
  coming_back: "Return",
  the_link_of_the_carpet_you_want: "Link of the Carpet You Want",
  landing_tab: "For a full introduction of each section from the top menu and quicker access, use the bottom menu.",
  carpet_replacement: "Carpet Replacement",
  submit: "Submit",
  receiving_information: "Receiving Information",
  // login form
  login_register_tab_login: "Login",
  login_register_tab_register: "Register",
  login_register_input_email: "Email",
  login_register_input_password: "Password",
  login_register_input_repassword: "Re Password",
  login_register_btn_close: "Close",
  login_register_btn_submit_login: "Login",
  login_register_btn_submit_register: "Register",
  login_register_btn_exit: "Logout",
  order_input_command: "Comment",
  order_btn_submit: "Submit",
  preview_btn_open_file_dialog: "Upload Background Image",
  preview_btn_show_3d: "3D",
  preview_btn_totate: "Horizontal",
  preview_slider_prespective: "Perspective",
  preview_slider_size: "Size",
  preview_slider_angle_up_down: "Up and down angle",
  preview_slider_angle_left_right: "Left and right angle",
  preview_slider_rotate: "Rotation",
  profile_btn: "Profile",
  profile_txt_first_name: "First Name",
  profile_txt_last_name: "Last Name",
  profile_txt_phone_number: "Phone Number",
};
